module.exports = __webpack_public_path__ + "static/media/nodejs.effdd946.png";